// eslint-disable-next-line import/prefer-default-export
export const isShowBurger = (width: number): boolean => {
  if (width <= 1024) return true;
  return false;
};
